<template>
  <div class="container">
    <h1 class="text-center mb-1 sm">
      <base-button v-on:click="goHome" size='md' class="mt-1 back-button" type="primary">Back</base-button>
      Forms
    </h1>
    <div class="panel panel-default">
    <div class="panel-body">
      <b-list-group>
        <b-list-group-item class="text-center">
          <a v-on:click='goToPirates' class="pointer">Pirates</a>
        </b-list-group-item>
        <b-list-group-item class="text-center" v-for="form in customForms" :key="form.formName">
          <a v-on:click='goToCustomForm(form.formName)' class="pointer">{{form.formLabel}}</a>
        </b-list-group-item>
      </b-list-group>
      <div class="text-center">
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import customFormsMixin from './../mixins/customFormsMixin'
export default {
  data () {
    return {
      form: {},
      formsLabelList: [],
      fields: [],
      model: {
        id: 1,
        name: 'John Doe',
        password: 'J0hnD03!x4',
        skills: ['Javascript', 'VueJS'],
        email: 'john.doe@gmail.com',
        status: true
      },
      schema: {
        fields: []
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  },
  computed: {
    customForms () {
      return this.$store.state.customForms
    }
  },
  methods: {
    goToCustomForm (formLabel) {
      this.$store.commit('setCurrentCustomForm', formLabel)
      this.$router.push({ path: 'customform' })
    },
    goToPirates () {
      this.$router.push({ name: 'pirates', params: { fromForms: true } })
    },
    getForms () {
      this.formsLabelList = this.getCustomFormsNamesArray()
    },
    goHome () {
      this.$router.push('/')
    }
  },
  mounted () {
    this.getForms()
  },
  mixins: [customFormsMixin]
}
</script>
<style scoped>
  .form-control.is-invalid {
    background-image: none;
  }
  .pointer {
    cursor: pointer;
  }
</style>
